import React, { useCallback } from 'react';
import { useHistory } from 'react-router';
import { URL } from '../../../../constant';
import { MenuButton } from '../../../navigate';

function MyPageHeader() {
  const history = useHistory();

  const handlePage = useCallback((path) => {
    if (path) history.push(path);
    else history.goBack();
  }, [history]);

  return (
    <div className="header_top gm">
      <div className="inner">
        <div className="btns_wrap header-trans cls">
          <div className="center_wrap cls pc_w1400">
            <div className="tit_area">
              <button
                type="button"
                className="btn_exit hide_pc hide_m"
                onClick={() => handlePage()}
              >
                <img src="./static/images/icon/ic_back@2x.png" alt="" />
              </button>
              <button
                type="button"
                className="btn_exit3 hide_pc hide_t"
                onClick={() => handlePage()}
              >
                <img src="./static/images/icon/ic_ar_left.svg" alt="" />
              </button>
              <button
                className="tit_btn"
                type="button"
                onClick={() => handlePage()}
              >MY</button>
            </div>
            <div className="right_area">
              <div className="menu_btn">
                <button
                  className="head_btn purple"
                  type="button"
                  onClick={() => handlePage(URL.COURSE_LEARNING.LEARNING_NOTE)}
                >
                  <img src="./static/images/icon/ic_gm_note_2@2x.png" alt="" />
                </button>
                <MenuButton iconPath={'/static/images/icon/ic_mn_w@2x.png'} />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default MyPageHeader;